import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FirebaseService } from '../../service/firebase.service';

@Component({
  selector: 'app-tagsmanagement',
  templateUrl: './tagsmanagement.component.html',
  styleUrls: ['./tagsmanagement.component.scss']
})
export class TagsmanagementComponent implements OnInit {
  public inputValue: string;
  constructor(public dialogRef: MatDialogRef<TagsmanagementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _firebase: FirebaseService) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    //console.log(this.data)
  }


  addTags(str) {
    if (this.data.mediaOptions.tags == undefined) {
      this.data.mediaOptions.tags = [];
    }

    this.data.mediaOptions.tags.push(str);

   // console.log(this.data.mediaOptions)

    this._firebase.updateMediaData({ tags: this.data.mediaOptions.tags }, this.data.id).then(() => {
      this._firebase.updateModule(this.data.moduleId, { latestUpdate: new Date() })
    })

    this.inputValue = null
  }


  removeTags(index) {
    this.data.mediaOptions.tags.splice(index, 1);


    this._firebase.updateMediaData({ tags: this.data.mediaOptions.tags }, this.data.id).then(() => {
      this._firebase.updateModule(this.data.moduleId, { latestUpdate: new Date() })
    })
  }

  close(data) {
    this.dialogRef.close(data)
  }

}
